export default __webpack_public_path__ + "static/media/star.7f3021d0.png";